/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {injectIntl} from 'react-intl';
import * as FleetActions from './FleetActions'
import {Grid, Pagination} from "@scuf/common";
import Loader from '../common/Loader'
import BreadCrumb from "../common/Bradcrumb";
import {getBreadcrumbItemsAssetHda} from "../utils/Helpers";
import ExpandableCard from "../common/ExpandableCard";
import AssetCard from "./AssetCard"
import Filter from "./Filter";
import {FLEETS_SORT} from "./FleetsConst";
import FleetChart from "../common/FleetChart";
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";

class Assets extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            filter: {
                search: '',
                sort: FLEETS_SORT.NAME,
            },
            assetCount: 0,
            faultsCount: 0,
            assetsFaultStatesCount: [],
            assetsOnPage: [],
            activePage: 1,
            cardsPerPage: 12,
        }

        this.searchChanged = this.searchChanged.bind(this)
        this.sortChanged = this.sortChanged.bind(this)
    }

    loadList(page, cardsPerPage) {
        const totalItemsPerPage = page * cardsPerPage
        const firstItemInCurrentPage = totalItemsPerPage - cardsPerPage;
        const lastItemInCurrentPage = firstItemInCurrentPage + cardsPerPage

        this.setState({
            assetsOnPage: this.props.fleet.assets.slice(firstItemInCurrentPage, lastItemInCurrentPage),
        })
    }

    componentDidMount() {
        this.fetchAssetsForTheFirstTime();
    }

    componentDidUpdate(prevProps) {
        if (this.props.fleet.assets !== prevProps.fleet.assets) {
            this.loadList(this.state.activePage, this.state.cardsPerPage);
        }
    }

    componentWillUnmount() {
        this.props.FleetActions.clearState()
    }

    fetchCards() {
        this.fetchAssets(this.state.filter.search, this.state.filter.sort)
    }

    fetchAssetsForTheFirstTime() {
        return this.props.FleetActions.fetchAssetsWithoutFleetForTheFirstTime(this.state.filter.search, this.state.filter.sort)
    }

    fetchAssets() {
        return this.props.FleetActions.fetchAssetsWithoutFleet(this.state.filter.search, this.state.filter.sort)
    }

    getAttributesComponents(fleet) {
        const column1Attrs = []
        const column2Attrs = []

        column1Attrs.push(this.getAttributeRow(fleet, 'assetCount'))
        column2Attrs.push(this.getAttributeRow(fleet, 'faultsCount'))

        return <ExpandableCard
            expandable={false}
            content={<Grid><Grid.Row><Grid.Column width={6}>{column1Attrs}</Grid.Column><Grid.Column
                width={6}>{column2Attrs}</Grid.Column></Grid.Row></Grid>}
            interactive={false}
            className='attributes-card'
        />
    }

    getAttributeRow(fleet, key) {
        const {intl} = this.props
        const name = intl.formatMessage({id: 'fleet.attr.' + key})
        return <Grid.Row key={key}><Grid.Column width={5}>{name}:</Grid.Column><Grid.Column width={7} className="attr-value">{fleet[key]}</Grid.Column></Grid.Row>
    }

    getAssetCards() {
        return this.state.assetsOnPage.map(a =>
            <Grid.Column width={3} sWidth={12} mWidth={4} key={a.id}><AssetCard asset={a} /></Grid.Column>)
    }

    searchChanged(search) {
        this.setState({
            filter: {
                ...this.state.filter,
                search: search,
            },
            activePage: 1,
        }, this.fetchCards)
    }

    sortChanged(sort) {
        this.setState({
            filter: {
                ...this.state.filter,
                sort: sort,
            },
            activePage: 1,
        }, this.fetchCards)
    }

    cleanFilter(callback) {
        return this.setState({
            filter: {
                ...this.state.filter,
                search: '',
            },
        }, callback)
    }

    render() {
        const {intl, fleet, userProfile} = this.props
        const {cardsPerPage, activePage} = this.state;

        const breadcrumbComponent = <BreadCrumb
            items={getBreadcrumbItemsAssetHda(intl.formatMessage({id: "admin.tab.only.assets"}),
                userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY))}/>

        const fleetInfo = fleet.details != null ? this.getAttributesComponents(fleet.details) : null
        const fleetCards = this.getAssetCards()

        return (
            <div id="fleet-detail">
                {breadcrumbComponent}
                <Loader loading={this.props.fleet.loading}/>
                <Grid className="fleet-header">
                    <Grid.Row>
                        <Grid.Column width={4} xsWidth={12}>
                            <h2>{intl.formatMessage({id: "page.assets"})}</h2>
                            {
                                fleet.details != null ?
                                    <div className="chart">
                                        <FleetChart fleet={fleet.details} height={220} />
                                    </div>
                                    :
                                    null
                            }
                        </Grid.Column>
                        <Grid.Column width={6} xsWidth={12}>
                            {fleetInfo}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <Loader loading={this.props.fleet.subResourceLoading}/>
                <Filter search={this.state.filter.search} searchChanged={this.searchChanged} className="fleets-filter"
                        sort={this.state.filter.sort} sortOptions={FLEETS_SORT} sortChanged={this.sortChanged}/>
                <Grid className="fleets-grid">
                    <Grid.Row>
                        {fleetCards}
                    </Grid.Row>
                    <Pagination
                        totalItems={this.props.fleet.assets.length}
                        activePage={activePage}
                        itemsPerPage={cardsPerPage}
                        boundaryRange={3}
                        itemsPerPageOptions={[12, 24, 48]}
                        onPageChange={(page, itemsPerPage) => {
                            this.setState({activePage: page, cardsPerPage: itemsPerPage});
                            this.loadList(page, itemsPerPage);
                        }}
                    />
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fleet: state.fleet,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FleetActions: bindActionCreators(FleetActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Assets)))